import { Navigate, useLocation } from "react-router-dom";
import { checkTokenValidity } from "../utils/auth";
import { hasPermission } from "../utils/auth";

export default function PrivateRoute({ children, requiredPermission }) {
  const { valid, reason } = checkTokenValidity();
  const location = useLocation();

  if (!valid) {
    // not logged in or expired
    return (
      <Navigate to="/" replace state={{ error: reason, from: location }} />
    );
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    // logged in but not allowed
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
